import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CurrentDateTime from "../components/CurrentDateTime";
import JNLogo from "../components/JNLogo";
// import Footer from "../components/Footer";

function ConfirmationScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const responseData = state && state.responseData;
  const requestData = state && state.requestData;
  const { branchName } = requestData || {};

  const {
    name,
    email,

    serviceName,

    scheduledOn,
    timeStart,
    timeEnd
  } = requestData || {};

  const referenceCode = responseData ? responseData.referenceCode : "";

   const [bgImageLoaded, setBgImageLoaded] = useState(true);
  
      useEffect(() => {
      const img = new Image();
      img.src = "/assets/images/bookonline-bg1.jpg";
      img.onload = () => setBgImageLoaded(true);
      img.onerror = () => setBgImageLoaded(false);
    }, []);

  return (
    <>
      <section
        className="d-table w-100"
        id="home"
      //  style={{
     
      //   backgroundColor: "gray",
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      //   backgroundRepeat: "no-repeat",
      //   minHeight: "100vh",
      //   backgroundAttachment: 'fixed',
      //   paddingTop: '80px',
      // }}
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(/assets/images/bookonline-bg.jpeg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          backgroundAttachment: "fixed",
          paddingTop: "80px",
          position: "relative",
        }}
    >
      <JNLogo />
      
        <CurrentDateTime />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-3"></div>
            <div className="col-lg-9">
              <div className="card rounded text-center" style={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: '1px solid #424242',
                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px'
              }}>
                <h1 className="sub-title mb-2 mt-4" style={{ color: '#000' }}>Appointment Confirmation</h1>
                {referenceCode ? (
                  <>
                    <p className="para-desc mx-auto" style={{ color: '#000' }}>
                      Hi {name}, We're delighted to inform you that your appointment
                      has been successfully scheduled at our {branchName} for the {serviceName} service.
                    </p>
                    <p className="para-desc mx-auto" style={{ color: '#000' }}>
                      Thank you for choosing our services. We look forward to
                      assisting you.
                    </p>
                    <nav aria-label="breadcrumb" className="d-inline-block">
                      <ul className="breadcrumb bg-transparent mb-0">
                        <li className="breadcrumb-item" style={{ color: '#396cf0', fontSize: "20px", }}>
                          Date and Time: {scheduledOn} / {timeStart}-{timeEnd}
                        </li>
                      </ul>
                      <p style={{ color: '#000', fontSize: "20px", textTransform: "uppercase" }}>This is your confirmation code</p>
                      <h1 style={{ fontSize: "75px", color: "#396cf0", }}>
                        {referenceCode}
                      </h1>
                      <p style={{ color: '#000' }} className="mb-4 mt-0">
                        We have sent an email to <span style={{ color: '#396cf0', }}> {email} </span>with the
                        complete information about this appointment.
                      </p>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-primary mt-2 mb-2"
                          onClick={() => navigate('/')}
                        >
                          Go to Home
                        </button>
                      </div>
                    </nav>
                  </>
                ) : (
                  <p className="para-desc mx-auto text-muted">Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
}

export default ConfirmationScreen;
